import { ReactNode } from 'react'

import { cn } from '@/utils'

interface PropsIn {
  className?: string
  tip?: string | ReactNode
}

const ScrollEnd = (props: PropsIn) => {
  const { className, tip } = props
  return (
    <div
      className={cn(
        'relative flex h-[101px] w-[237px] items-end justify-center overflow-hidden',
        "before:absolute before:left-0 before:top-0 before:h-[134px] before:w-[134px] before:bg-[url('@/assets/images/MaskGroup.svg')] before:bg-[length:100%_100%] before:bg-center before:bg-no-repeat before:content-['']",
        "after:absolute after:bottom-[-2px] after:left-1/2 after:h-0 after:w-[193px] after:-translate-x-1/2 after:border-[2px] after:border-solid after:content-[''] after:[border-image:var(--discover-page-end)_2_2]",
        className,
      )}
    >
      {tip ? tip : <span className='mb-[7px] h-[34px] font-geologica text-[26px] font-normal text-base-text-color'>In The End</span>}
    </div>
  )
}

export default ScrollEnd
